import { useEffect } from 'react';

export const NoMobile = () => {
	useEffect(() => {
		document.getElementById('main-sidebar-nav')?.classList.add('d-none');
		document.getElementsByClassName('footer')[0]?.classList.add('d-none');
	}, []);

	return (
		<section id='content2'>
			<div
				style={{
					margin: '0 auto',
					textAlign: 'center'
				}}
			>
				<img
					style={{ width: '100%' }}
					src='https://triple-innovations.com/ofcaCDN/illustration-3.svg'
					alt='ofca.rocket'
				/>
				<h4 style={{ width: '100%' }}>
					Ofca is best used on big screen, please use desktop device!
				</h4>
			</div>
		</section>
	);
};
